// Pantalla en blanco después de publicar una versión nueva (Vale, 11-oct-2026: «a veces se queda blanco y me toca
// refrescar»). Una pestaña abierta con la versión anterior pide al navegar un archivo de código que ya no existe; el
// servidor responde con la página principal y la carga falla sin mostrar nada. Aquí se recarga una vez la página para
// tomar la versión nueva y, si el error sigue, se muestra un aviso con el botón para recargar en vez de la pantalla blanca.
import { Component, type ReactNode } from 'react';

const CLAVE = 'upk-recarga-version';
const ESPERA_MS = 30_000;

/** Recarga la página una sola vez cada 30 s (evita un ciclo de recargas si el error no es de versión). */
export function recargarPorVersion(): boolean {
  let ultima = 0;
  try {
    ultima = Number(sessionStorage.getItem(CLAVE) ?? 0);
  } catch {
    /* sin almacenamiento de sesión: se recarga igual */
  }
  if (Date.now() - ultima < ESPERA_MS) return false;
  try {
    sessionStorage.setItem(CLAVE, String(Date.now()));
  } catch {
    /* sin almacenamiento de sesión */
  }
  window.location.reload();
  return true;
}

const esErrorDeCarga = (e: unknown) =>
  /dynamically imported module|Importing a module script failed|error loading dynamically|Failed to fetch|ChunkLoadError|MIME type/i.test(
    String((e as { message?: string })?.message ?? e),
  );

/** Escucha el evento de Vite cuando no carga un archivo de la versión anterior. */
export function instalarRecargaPorVersion(): void {
  window.addEventListener('vite:preloadError', (ev) => {
    if (recargarPorVersion()) ev.preventDefault();
  });
}

export class ErrorRecarga extends Component<{ children: ReactNode }, { error: unknown }> {
  state = { error: null as unknown };

  static getDerivedStateFromError(error: unknown) {
    return { error };
  }

  componentDidCatch(error: unknown) {
    if (esErrorDeCarga(error)) recargarPorVersion();
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="pagina" role="alert" style={{ maxWidth: 560, margin: '80px auto', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.25rem', marginBottom: 12 }}>Hay una versión nueva de UPK INNOVA</h1>
        <p style={{ marginBottom: 20 }}>Recargue la página para seguir trabajando. Lo que ya guardó se conserva.</p>
        <button type="button" className="btn btn--primario" onClick={() => window.location.reload()}>
          Recargar
        </button>
      </div>
    );
  }
}
